import { Pipe, PipeTransform } from '@angular/core';
import { ValidationErrors } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'formError'
})
export class FormErrorPipe implements PipeTransform {

  constructor(private translateService: TranslateService) { }

  transform(value: ValidationErrors, args?: any): string {
    if (typeof value !== 'object') {
      return value;
    }

    for (const error in value) {
      if (value.hasOwnProperty(error)) {
        switch (error) {
          case 'required': {
            if (value['matDatepickerParse']) {
                return this.translateService.instant('APP.VALIDATION.DATE_FORMAT');
            }
            return this.translateService.instant('APP.VALIDATION.REQUIRED');
          }
          case 'email': {
            return this.translateService.instant('APP.VALIDATION.EMAIL');
          }
          case 'max': {
            return this.translateService.instant('APP.VALIDATION.MAX', {max: value[error].max, actual: value[error].actual});
          }
          case 'min': {
            return this.translateService.instant('APP.VALIDATION.MIN', {min: value[error].min, actual: value[error].actual});
          }
          case 'pattern': {
            return this.translateService.instant('APP.VALIDATION.PATTERN');
          }
          case 'phone': {
            return this.translateService.instant('APP.VALIDATION.PHONE');
          }
          case 'nip': {
            return this.translateService.instant('APP.VALIDATION.NIP');
          }
          case 'nipFormat': {
            return this.translateService.instant('APP.VALIDATION.NIP_FORMAT');
          }
          case 'nipControlNumber': {
            return this.translateService.instant('APP.VALIDATION.NIP_CONTROL_NUMBER');
          }
          case 'regon': {
            return this.translateService.instant('APP.VALIDATION.REGON');
          }
          case 'regonFormat': {
            return this.translateService.instant('APP.VALIDATION.REGON_FORMAT');
          }
          case 'regonControlNumber': {
            return this.translateService.instant('APP.VALIDATION.REGON_CONTROL_NUMBER');
          }
          case 'mask': {
            return this.translateService.instant('APP.VALIDATION.POSTAL_CODE1');
          }
          case 'gln': {
            return this.translateService.instant('APP.VALIDATION.GLN');
          }
          case 'maxlength': {
            return this.translateService.instant(
              'APP.VALIDATION.MAX_LENGTH',
              {
                requiredLength: value[error].requiredLength,
                actualLength: value[error].actualLength
              }
            );
          }
          case 'minlength': {
            return this.translateService.instant(
              'APP.VALIDATION.MIN_LENGTH',
              {
                requiredLength: value[error].requiredLength,
                actualLength: value[error].actualLength
              }
            );
          }
          case 'postalzone': {
            return this.translateService.instant('APP.VALIDATION.POSTAL_ZONE');
          }
          case 'key': {
            return this.translateService.instant(value[error]);
          }
          case 'matDatepickerParse': {
            return this.translateService.instant('APP.VALIDATION.DATE_FORMAT');
          }
          case 'Mask error': {
            return this.translateService.instant('APP.VALIDATION.POSTAL_ZONE');
          }
          case 'requiredIfOtherHasValue': {
            return this.translateService.instant('APP.VALIDATION.REQUIRED_IF_OTHER_HAS_VALUE');
          }
          case 'nonZero': {
            return this.translateService.instant('APP.VALIDATION.NON_ZERO');
          }
          default: {
            return this.translateService.instant('APP.VALIDATION.VALIDATION_ERROR');
          }
        }
      }
    }
    return '';
  }
}
